import { FC, ReactNode, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

/**
 * Rückfrage vor einer Aktion mit Folgen für Kunden (Löschen, Depublizieren, Sendung absagen, Not-Aus).
 * Sagt in Klartext, was danach passiert. Mit `bestaetigungsWort` muss man es eintippen (z. B. das Kürzel des
 * Webinars) — für Aktionen, die sich nicht rückgängig machen lassen.
 */
const GefahrBestaetigung: FC<{
  open: boolean;
  titel: string;
  /** Was passiert danach — für Kunden und intern. */
  wirkung: ReactNode;
  knopfText: string;
  bestaetigungsWort?: string;
  laeuft?: boolean;
  fehler?: string | null;
  onBestaetigen: () => void;
  onAbbrechen: () => void;
}> = ({
  open,
  titel,
  wirkung,
  knopfText,
  bestaetigungsWort,
  laeuft,
  fehler,
  onBestaetigen,
  onAbbrechen,
}) => {
  const [eingabe, setEingabe] = useState('');
  useEffect(() => {
    if (open) setEingabe('');
  }, [open]);
  const passt = !bestaetigungsWort || eingabe.trim() === bestaetigungsWort;
  return (
    <Dialog open={open} onClose={laeuft ? undefined : onAbbrechen} maxWidth="sm" fullWidth>
      <DialogTitle>{titel}</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {wirkung}
        </Alert>
        {bestaetigungsWort && (
          <>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Zum Bestätigen bitte <strong>{bestaetigungsWort}</strong> eintippen:
            </Typography>
            <TextField
              autoFocus
              fullWidth
              size="small"
              value={eingabe}
              onChange={(e) => setEingabe(e.target.value)}
              placeholder={bestaetigungsWort}
            />
          </>
        )}
        {fehler && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {fehler}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onAbbrechen} disabled={laeuft}>
          Abbrechen
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onBestaetigen}
          disabled={!passt || laeuft}
          startIcon={laeuft ? <CircularProgress size={14} /> : undefined}
        >
          {knopfText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GefahrBestaetigung;
